export default __webpack_public_path__ + "static/media/arayeshi-stand.bd84e5f9.png";